import { useState } from 'react';
import {
  AdSpendCard as BaseAdSpendCard,
  AdSpendCardProps as BaseAdSpendCardProps,
} from '@features/campaigns/components/AdSpendCard';
import { useCurrentAdSpend } from '../../../hooks/useAdSpend';
import { InputAdornment, TextField } from '@mui/material';

type AdSpendCardProps = Omit<BaseAdSpendCardProps, 'adSpendHook'>;

export const AdSpendCard = (props: AdSpendCardProps) => {
  const adSpendHook = useCurrentAdSpend();
  const [inputValue, setInputValue] = useState<string | number>(
    adSpendHook.adSpend?.toString() ?? ''
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value === '') {
      setInputValue('');
      return;
    }

    // Only allow numeric values
    if (/^\d*$/.test(value)) {
      setInputValue(value);
    }
  };

  const handleBlur = () => {
    const newValue =
      inputValue === '' ? adSpendHook.adSpend : Number(inputValue);
    adSpendHook.updateSessionAdSpend?.(newValue);
    setInputValue(newValue?.toString() ?? '0');
  };

  return (
    <BaseAdSpendCard {...props}>
      <TextField
        label="Ad Spend"
        value={inputValue}
        slotProps={{
          htmlInput: { inputMode: 'numeric', pattern: '[0-9]*' },
          input: {
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          },
        }}
        onChange={handleChange}
        onBlur={handleBlur}
        fullWidth
      />
    </BaseAdSpendCard>
  );
};
